import React from 'react';
import PropTypes from 'prop-types';
import './YearNavigation.css';

/**
 * YearNavigation - Standardized year navigation component
 * Provides prev/next year buttons and a "go to today" button
 */
const YearNavigation = ({
  year,
  onPreviousYear,
  onNextYear,
  onToday,
  todayLabel = 'Today',
  size = 'md',
}) => {
  return (
    <div className={`ml-year-nav ${size !== 'md' ? `ml-year-nav--${size}` : ''}`}>
      <h1 className="ml-year-nav__year">{year}</h1>
      <div className="ml-year-nav__buttons">
        <button
          className="ml-year-nav__button ml-year-nav__button--prev"
          onClick={onPreviousYear}
          aria-label="Previous year"
          type="button"
        >
          <i className="fa-solid fa-chevron-left" />
        </button>
        <button
          className="ml-year-nav__button ml-year-nav__button--today"
          onClick={onToday}
          aria-label="Go to today"
          type="button"
        >
          {todayLabel}
        </button>
        <button
          className="ml-year-nav__button ml-year-nav__button--next"
          onClick={onNextYear}
          aria-label="Next year"
          type="button"
        >
          <i className="fa-solid fa-chevron-right" />
        </button>
      </div>
    </div>
  );
};

YearNavigation.propTypes = {
  year: PropTypes.number.isRequired,
  onPreviousYear: PropTypes.func.isRequired,
  onNextYear: PropTypes.func.isRequired,
  onToday: PropTypes.func.isRequired,
  todayLabel: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default YearNavigation;
